// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"cd540ee4","453":"4aff8b9d"}[chunkId] + ".chunk.js";
};